var $a3d99ea5d46a3d12$exports = {};
$a3d99ea5d46a3d12$exports = {
  "pending": "\u0432 \u043E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u0456"
};
export { $a3d99ea5d46a3d12$exports as default };